export function fetchGameDevelopers(GameDevelopersResource) {
  return function (dispatch) {
    return GameDevelopersResource.getList().then((gameDevelopers) => {
      return dispatch({type: 'GAME_DEVELOPERS_FETCH_SUCCESS', gameDevelopers});
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/gameDevelopers-actions.js
 **/